import slugify from 'slugify'

const pageAlternatesUrls = (
  page,
  alternatePage,
  type,
  frPath,
  enPath,
  locale,
) => {
  let pageURL
  let alternateURL = null

  if (type === 'slug') {
    pageURL = `${page.node_locale === 'fr' ? '/' : '/en/'}${page.slug}`

    if (alternatePage !== null) {
      alternateURL = `${alternatePage.node_locale === 'fr' ? '/' : '/en/'}${alternatePage.slug}`
    }
  } else {
    pageURL = `${page.node_locale === 'fr' ? frPath : enPath}${slugify(page.title, { remove: /[*+~.()'"!?:@,]/g }).toLowerCase()}`

    if (alternatePage !== null) {
      alternateURL = `${alternatePage.node_locale === 'fr' ? frPath : enPath}${slugify(alternatePage.title, { remove: /[*+~.()'"!?:@,]/g }).toLowerCase()}`
    }
  }

  const frUrl = locale === 'fr' ? pageURL : alternateURL
  const enUrl = locale === 'en' ? pageURL : alternateURL

  return { frUrl, enUrl }
}

export default pageAlternatesUrls
